<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';
import {
  inboxBrandName,
  getInboxIdentifier,
  isEmailChannel,
} from 'dashboard/helper/inbox';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
  // Email: la casella e' la distinzione (EasyPay arriva identico da ogni store).
  emphasize: {
    type: Boolean,
    default: false,
  },
});

const brand = computed(() => inboxBrandName(props.inbox));
const identifier = computed(() => getInboxIdentifier(props.inbox));
const showMailbox = computed(
  () => isEmailChannel(props.inbox) && Boolean(identifier.value)
);
const title = computed(() =>
  [brand.value, identifier.value].filter(Boolean).join(' · ')
);
</script>

<template>
  <div :title="title" class="flex items-center gap-1 min-w-0">
    <ChannelIcon :inbox="inbox" use-brand-icon class="size-4 flex-shrink-0" />
    <span
      class="truncate text-label-small"
      :class="emphasize ? 'font-semibold text-n-slate-12' : 'text-n-slate-11'"
    >
      {{ brand }}
    </span>
    <span v-if="showMailbox" class="truncate text-xs text-n-slate-10 min-w-0">
      {{ identifier }}
    </span>
  </div>
</template>
